import { Grid, Stack, Typography } from '@mui/material';

interface TrainingManagementStatusProps {
  totalPrograms: number;
  assignmentStatus: number;
  completionRate: string;
  overdue: number;
  activeCount: number;
  totalCompleted: number;
}

const TrainingManagementStatus: React.FC<TrainingManagementStatusProps> = (
  props
) => {
  const {
    totalPrograms,
    assignmentStatus,
    completionRate,
    overdue,
    activeCount,
    totalCompleted,
  } = props;
  return (
    <Grid container className="risk-assessments-container">
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Total programs</Typography>
          <Typography variant="body1">{totalPrograms}</Typography>
          <Typography component="span">{activeCount} active</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Assignments</Typography>
          <Typography variant="body1">{assignmentStatus}</Typography>
          <Typography component="span">{totalCompleted} completed</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Completion rate </Typography>
          <Typography variant="body1">
            {Math.ceil(Number(completionRate))}%
          </Typography>
          <Typography component="span">Across all programs</Typography>
        </Stack>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Stack direction="column">
          <Typography component="span">Overdue</Typography>
          <Typography variant="body1">{overdue}</Typography>
          <Typography component="span">Require attention</Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default TrainingManagementStatus;
